export default {
  home: {
    minute: 'minute',
    price_info: '{mianfei} minutes free, ',
    price_info1: 'maximum per day  {currencyName}{fengding}, ',
    price_info3: 'deposit {currencyName}{yajin},  free rental deposit',
    price_info2: 'All monthly members are free of deposit / rent per time (return within 48 hours), and can rent for unlimited times. If a single lease is overdue, please pay the standard rent of ordinary members.',
    price_info4: 'Service for Students and Staff of The Hong Kong Polytechnic University',
    // feature_1: 'Special design for wireless charging',
    // feature_2: 'Hong Kong Everywhere',
    // feature_3: 'Four charging modes, suitable for all mobile phones',
    feature_1: 'High quality lithium battery with abundant current',
    feature_2: 'All rental points in Hong Kong and Macao can be used',
    feature_3: 'Charger built-in wireless charging + three mainstream plug wires',
    feature_4_title: 'Service Rules & Regulations: ',
    feature_4: 'Please make a deposit of {currencyName} {yajin} in advance. Each rental allows for 7 days (10,080 minutes) of shared power bank rental service. Overdue payments will be charged at the standard rates ({currencyName}{jifei} per {jifeiDanwei} minutes with a maximum daily rental fee of {currencyName}{fengding}).',
    feature_5: 'This rental service is only available for rental and return within the campus of The Hong Kong Polytechnic University.',
    feature_6_title: 'Refund of deposit: ',
    feature_6: 'After returning the power bank, you can scan the QR code on the LED screen of the charging machine and apply for a refund of the deposit from your account\'s wallet. The deposit will be refunded through the original payment gateway within 0-1 day by a third-party payment platform.',
    // tips_1: ' Insufficient balance, please reload the deposit before renting',
    tips_1: 'Unpaid deposit, deposit {currencyName} {yajin} needs to be paid before use',
    tips_2: 'Reloaded deposit {currencyName}{yajin} , it can be refund after use',
    tips_3: 'The balance {currencyName}{myyue}, Rent now',
    tips_4: 'The deposit {currencyName}{myyajin}, Rent now',
    tips_5: 'You are a VIP user, you can rent directly',
    submit: 'Recharge',
    borrow: 'Borrow',
    msg_fail_title: 'Error',
    msg_fail_content: 'Rental failed, please try again',
    goborrow: 'Go to charge!!!',
    download_app: 'Use APP to download/open',
    download: 'Jump to app or app market',
    wechat_download_tips: 'Please click the top right corner to open the download app in the browser'
  },
  login: {
    code_title: 'SMS verification',
    phone_number: 'Please enter an {0}-digit mobile number ',
    verification_code: 'Please enter SMS verification code',
    captcha_code: 'Code',
    send_code: 'Send Code',
    login: 'Login',
    submit: 'Submit',
    agree: 'By clicking Login, you agree to ',
    readme: `User Agreement`,
    msg_fail_login: 'Login failed',
    msg_success_login: 'Login successful',
    exchangesuccess: 'Redemption successful',
    msg_success_login_code: 'Successfully received, please download the APP to log in to use',
    msg_fail_user: 'Error getting user information. Do you want to try again?',
    sign_in_with: 'Sign in with',
    no_sms: 'Did not receive text message',
    retry: 'Resend',
    receive: 'Apply',
    invite_pwd: 'Invitation code',
    couponcode: 'Please enter Code',
    vip_agreen_tip: 'By continuing, you are indicating that you accept our',
    vip_agreen_service: 'Terms of Service',
    vip_agreen_and: 'and',
    vip_agreen_policy: 'Privacy Policy'
  },
  confirm: {
    title: 'Payment Confirmation',
    pay_label: 'Amount',
    auth_label: 'Pre-authorization',
    price_tips: 'Click to confirm payment, indicating that you have read and agreed to the ',
    price_btn: '《Value-added Agreement》',
    auth_tips: 'A pre-authorization of {currencyName}{yajin} is compulsory. The amount of actual rent occurred will be deducted when the powerbank is returned.',
    pay_type: 'Please select your preferred payment method',
    submit: 'Confirm payment',
    msg_loading: 'Loading...',
    msg_fail_title: 'Warning',
    msg_fail_payment: 'Failed to initiate deposit payment',
    msg_fail_order: 'Failed to create lease order',
    msg_fail_support: 'The system is not supported',
    msg_fail_confirm: 'Confirm',
    msg_fail_retry: 'Retry',
    msg_fail_cancel: 'Cancel',
    支付宝: 'Alipay',
    支付宝HK: 'AlipayHK',
    银联: 'UnionPay',
    微信: 'WeChat',
    PayPal: 'PayPal',
    paypalsubmsg: 'Users will have the option to check out using a Visa/Mastercard,AE and Diners Club'
  },
  mine: {
    title: 'User Profile',
    wallet: 'Wallet/Deposit',
    deposit: 'Deposit',
    wallet_in: 'Pay HK$',
    nouse: 'Not Applicable',
    wallet_out: 'Axpply refund of deposit',
    wallet_log: 'Wallet Log',
    order: 'My Order',
    coupon: 'Coupon Mart',
    coupon_cd: 'Power Loong Coupon',
    login_tips: 'Please Login',
    msg_fail_title: 'Error',
    msg_fail_update: 'Modification failed, please try again',
    msg_loading: 'Loading...',
    msg_fail_user: 'Error getting user information. Do you want to try again?',
    help: 'Help',
    setting: 'Setting',
    logout: 'Logout',
    buy: 'Buy equipment',
    prestore: 'Monthly VIP Pass',
    prestore_tips: 'Rental-Free for the first 48 hours, standard charges applies thereafter. Rent/Return across Hong Kong and Macao',
    prestore_tips2: 'Annual Pass: HK$828',
    prestore_type: 'Registered',
    prestore_type2: 'Not yet registered',
    prestore_date: 'Valid until',
    prestore_btn: 'Register now',
    single: 'Single Rental',
    single_tips: '(Direct payment with deposit of HK$198)',
    single_tips1: '(Just deposit HK$198)',
    single_tips2: 'HK$6 per hour, with maximum charge of 5 hours per day',
    balance: 'Balance',
    paid: 'Paid',
    unpaid: 'Unpaid',
    using: 'In Use',
    deposit_btn: 'Pay deposit',
    invitation: 'Invitation code',
    invite_btn: 'Invite friends',
    wallet_tips: 'Refund of deposit:',
    wallet_tips2: '1.Click"Pay the difference of deposit"',
    wallet_tips3: '2.The deposit will be refunded within 0-1 days.'
  },
  msg: {
    loading: 'Loading...',
    title: 'Hint',
    success: 'Successful operation',
    error: 'Unknown error,please try again later.',
    confirm: 'Confirm',
    retry: 'Retry',
    cancel: 'Cancel',
    title_fail: 'Warning',
    success_payment: 'Payment completed',
    success_buy: 'Buy completed',
    fail_payment: 'Payment failure',
    keyword: 'keyword',
    unpaid_order: 'There are unpaid orders',
    go_pay: 'Go pay',
    no_more: 'no more',
    payTitle: 'Purchase charging coupon',
    paySubTitle: 'Charging coupon fee',
    payVipTitle: 'Purchase VIP',
    payVipSubTitle: 'VIP fee',
    payYaJinTitle: 'Pay deposit',
    payYaJinSubTitle: 'Payment of fees',
    payZuJinTitle: 'Payment of rent',
    confirmpaytip: 'Please scan the WeChat QR code to make the payment and click "I have paid"'
  },
  result: {
    title: 'Result Confirmation',
    price_plan: 'Charge Standard',
    msg_success: 'Successfully Rented',
    msg_tips_loading: 'Portable battery is popping up, please wait patiently...',
    msg_result_loading: 'The payment result is being confirmed...',
    msg_fail_confirm: 'Confirm',
    btn_usage: 'Usage note',
    btn_return: 'Return note',
    deposit: 'Deposit',
    msg_fail_content: 'Reqest failed, please try again',
    price_label: 'per hour',
    price_info: 'Free of charge for the first {mianfei} mins，A maximum dialy charge of {ccurrency}{fengding}，Deposit will be automatically deducted when rent reaches {ccurrency}{yajin}',
    tips_1: 'Please collect power bank <span class="number">No.{number}</span> as the picture shown',
    tips_2: 'Please tidy the cables and insert the power bank to bottom with the <span class="highlight">[arrow downward]</span> when return',
    msg_note_usage: 'The power bank is equipped with 3 types of cables and wireless changing,please use as needed.',
    msg_note_return: 'Please tidy this cables and insert the power bank to the bootom with the [arrow downward] when return.',
    return_info: 'When return,set the cables well and insert the side with metal chips into an empty socket till it reaches the bottom and stabilized.'
  },
  result_msg: {
    loading: 'Loading...',
    refresh: 'Refresh'
  },
  order: {
    title: 'Lease Order',
    in_use: 'In use',
    ended: 'Ended',
    msg_error: 'Request failed',
    no_data: 'No Data'
  },
  order_item: {
    order_number: 'No.',
    venue_rented: 'Venue rented',
    time_rented: 'Time rented',
    venue_returned: 'Venue returned',
    time_returned: 'Time returned',
    charge_standard: 'Charge standard',
    // charge_standard_info: '{pJifei} {pCurrency} per hour(first {pMian} mins for free)',
    charge_standard_info: 'Charging standard of all month pass: all month pass members are free to rent for 48 hours each time; Charging standard for ordinary members: 6 yuan per 60 minutes, up to 30 yuan per day. Each lease is limited to 74 hours to return the payment, and the overdue will be deducted with all deposits.',
    rent_occurred: 'Rent occurred',
    returned: 'Returned',
    unreturned: 'Unreturned',
    type_0: 'Not Completed',
    type_1: 'Renting',
    type_2: 'Canceled',
    type_3: 'Returned',
    type_4: 'Fault occurred',
    type_5: 'Overtime',
    min: 'Min',
    unpaid: 'Unpaid',
    payment: 'Payment'
  },
  setting: {
    title: 'Setting',
    lang: 'Language'
  },
  help: {
    title: 'FAQ'
  },
  wallet_in: {
    title: 'Add Value',
    price_label: 'Value',
    price_placeholder: 'please enter the reload amount',
    balance: 'Balance',
    price_auto: 'The pre-stored fees can be used continuously, and the deposit is exempted from {0}',
    price_tips: 'Click to confirm payment, indicating that you have read and agreed to the ',
    price_btn: '《Value-added Agreement》',
    submit: 'Renew now',
    loading: 'Loading ...',
    paying: 'Direct to the payment page',
    msg_title: 'Reminder',
    msg_fail_order: 'the reload order is fail',
    msg_fail_payment: 'Payment fail',
    msg_fail_retry: 'Please try again',
    vip_tips: 'Register for All-Monthly VIP to enjoy free charging service',
    price_title: 'All Month VIP',
    price_title_1: 'Monthly Pass Member',
    price_title_2: 'Double Monthly Pass Member',
    price_title_3: 'Annual Pass Member',
    price_1: '(Single month fee)',
    price_2: '(Bimonthly fee)',
    price_3: '(Annual fee)',
    price_sub_title: 'Enjoy {0} days of free charging service',
    vip_title: 'Member exclusive charging privilege',
    vip_tips1: 'Free rental for 48 hours each time',
    vip_tips2: 'Available throughout Hong Kong',
    rule_title: 'Rules of Use:',
    rule_tips: '1. The monthly rental must be returned within 48 hours before you can continue to enjoy any rental services in Hong Kong. If the rental is overdue, the rent must be paid according to the standard of ordinary members.\n2. If the rental is overdue for 5 days, it will VIP membership is cancelled, and 5 days rent is required.\n3. Only one battery can be rented at a time.\n4. This membership service is a preferential treatment for a specified period of time. If you have any queries, please contact the customer service hotline: 852-2322 2956.\n5. In case of any disputes, HONG KONG CHARGE EASY LIMITED. reserves the right of final decision.'
  },
  wallet_out: {
    title: 'Withdrawal',
    price_label: 'Withdrawal amount',
    price_placeholder: 'Please enter the withdrawal amount',
    balance: 'Current balance',
    balance_all: 'Withdraw all',
    deposit: 'Deposit',
    deposit_tips: 'There is an lease order. The deposit of {pcurrencyName}{pyajin} is non-refundable',
    submit: 'Submit',
    apply: 'Apply',
    confirm: 'Confirm',
    loading: 'Loading...',
    msg_fail_price: 'The withdrawal amount is incorrect',
    msg_fail_balance: 'The withdrawal amount cannot be greater than the current balance',
    msg_title: 'Error',
    msg_success_content: 'Apply Refund successful',
    type1: 'Return',
    type2: 'Back to the mall',
    type3: 'Appointment return',
    tips_title: 'Explanation',
    tips1: 'Thank you for choosing the service of Power Loong! If you apply for a refund of the deposit paid before, the company will immediately notify the related payment platform for review and processing. The related payment platform will take about 0-1 working day to complete, please pay attention to the connection Platform notification.',
    tips2: 'The deposit will be refunded to the account you filled in. It will take 1-7 business days to process the refund of the account deposit. Please be patient.',
    input1: 'Mall phone number:',
    input2: 'Bank card number:',
    input3: 'Opening bank branch:',
    input4: 'Name:',
    btn: 'Submit',
    error_tips: 'Please enter complete information'
  },
  coupon: {
    title: 'Coupon',
    title_cd: 'Power Loong Coupon',
    input_tips: 'Please enter the coupon code',
    btn: 'Receive',
    coupon_type1: 'Rental coupons',
    coupon_type2: 'Merchant coupon',
    deadline: 'Valid period',
    divide: 'to',
    detail: 'Coupon details',
    instructions: 'Terms and conditions',
    restrict: 'Time limit:',
    tips1: '1. The shown value of each charging coupon can be used for offsetting the rent.',
    tips2: '2. Upon the completion of rental,the system will remind users for using a charging coupon to deduct the value of rental amount. The user has to settle the balance of the rent.',
    tips3: '3. Each coupon can only be used once.',
    tips4: '4. Only one coupon can be used per rental.',
    tips5: '5. This coupon is non-exchangeable for cash and/or used in conjunction with other discount offers. No change will be given either in cash or in other forms.',
    tips6: '6. HONG KONG CHARGE EASY LIMITED. reserves the right of final decision in case of any dispute arising herein.',
    code: 'Coupon code',
    category_0: 'other',
    category_1: 'Dining & Entertainment',
    category_2: 'Shopping retail',
    category_3: 'Beauty care',
    coupon_wb_tips: 'Please present this voucher before payment',
    shop: 'Store',
    coupon_toBeUsed: 'Available',
    coupon_buy: 'Purchase',
    coupon_haveBeenUsedOrPastDue: 'Used/Expired',
    coupon_pay_fee: 'HK$ {0}',
    coupon_paytype_title: 'Please select payment method',
    coupon_paytype_alipay: 'Alipay',
    coupon_paytype_alipayhk: 'AlipayHK',
    coupon_paytype_unionpay: 'UnionPay',
    coupon_pay_button: 'Confirm payment'
  }
}
